(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('EGSService', EGSService);

    EGSService.$inject = ['$http'];

    function EGSService($http) {
        var prototypeRange = {
            startDate: null,
            endDate: null
        };
        return {
            runEGS: runEGS,
            loadOrbitFileNames: loadOrbitFileNames,
            abort: abort,
            jobsStatusClass: jobsStatusClass,
            createEGSParameters: createEGSParameters,
            resetParamsInArray: resetParamsInArray,
            getDateRangesFromObj: getDateRangesFromObj,
            getDateRangesFromString: getDateRangesFromString,
            getPickerOpts: getPickerOpts
        };

        function runEGS(egsJOB, success, failure) {
            $http({
                method: 'POST',
                url: 'api/run-egs?label=' + egsJOB.label,
                data: JSON.stringify(egsJOB)
            }).then(success, failure);
        }

        function loadOrbitFileNames(success, failure) {
            $http({
                method: 'GET',
                url: 'api/egs-orbit-files'
            }).then(success, failure);
        }

        function abort(jobId, success, failure) {
            $http({
                method: 'PUT',
                url: 'api/abort?jobId=' + jobId
            }).then(success, failure);
        }

        function jobsStatusClass(jobStatus) {
            if (jobStatus === 'COMPLETED') {
                return 'label-success';
            } else if (jobStatus === 'FAILED' || jobStatus === 'FAILED_BAD_EXIT' || jobStatus === 'FAILED_SERVER_ERROR' || jobStatus === 'ABORTED') {
                return 'label-danger';
            } else if (jobStatus === 'N/A') {
                return 'label-default';
            } else {
                return ' label-warning';
            }
        }

        function createCruisePhaseParams() {
            var cruisePhaseParams = [];

            var checkoutWindows = {
                id: 'checkoutWindows',
                text: 'Cruise checkout windows',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(checkoutWindows);

            var cruisePassPrimaryDuration = {
                id: 'cruisePassPrimaryDuration',
                text: 'Normal cruise pass length (hours)',
                default: 8,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruisePassPrimaryDuration);

            var checkoutPassWindows = {
                id: 'checkoutPassWindows',
                text: 'Cruise checkout pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(checkoutPassWindows);

            var cruisePassSecondaryDurWindows = {
                id: 'cruisePassSecondaryDurWindows',
                text: 'Specific cruise pass length periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(cruisePassSecondaryDurWindows);

            var cruisePassSecondaryDuration = {
                id: 'cruisePassSecondaryDuration',
                text: 'Specific cruise pass length (hours)',
                default: -1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruisePassSecondaryDuration);

            var cruiseExtraPassPeriodDays = {
                id: 'cruiseExtraPassPeriodDays',
                text: 'Extra cruise passes frequency (days)',
                default: -1,
                min: -1,
                max: 30,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruiseExtraPassPeriodDays);

            var cruiseExtraPassWindows = {
                id: 'cruiseExtraPassWindows',
                text: 'Additional cruise pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(cruiseExtraPassWindows);
            return cruisePhaseParams;
        }

        function createNominalPhaseParams() {
            var nominalPhaseParams = [];

            var periRSWindows = {
                id: 'periRSWindows',
                text: 'Perihelion remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'Leave blank to for EGS to automatically schedule the windows as close as possible to perihelion; note the existence of any perihelion window date here will overwrite all automatically generated perihelion windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(periRSWindows);

            var maxRSWindows = {
                id: 'maxRSWindows',
                text: 'Maximum latitude remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'leave blank to for EGS to automatically schedule the windows as close as possible to the maximum latitude event; note the existence of any max latitude window date here will overwrite all automatically generated max latitude windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(maxRSWindows);

            var minRSWindows = {
                id: 'minRSWindows',
                text: 'Minimum latitude remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'leave blank to for EGS to automatically schedule the windows as close as possible to the minimum latitude event; note the existence of any minimum latitude window date here will overwrite all automatically generated minimum latitude windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(minRSWindows);

            var minPassLengthHours = {
                id: 'minPassLengthHours',
                text: 'Target pass length (hours)',
                default: 7,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(minPassLengthHours);

            var dailyPassAllocationHours = {
                id: 'dailyPassAllocationHours',
                text: 'Daily pass allocation (hours)',
                default: 9,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(dailyPassAllocationHours);

            var minExtraPassLengthHours = {
                id: 'minExtraPassLengthHours',
                text: 'Minimum length of extra passes (hours)',
                default: 2,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(minExtraPassLengthHours);

            var secondaryGSPassLimitHours = {
                id: 'secondaryGSPassLimitHours',
                text: 'Extra pass length (hours)',
                default: 9,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(secondaryGSPassLimitHours);

            var secondaryPassBoundSequence = {
                id: 'secondaryPassBoundSequence',
                text: 'Extra pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            nominalPhaseParams.push(secondaryPassBoundSequence);
            return nominalPhaseParams;
        }

        function createGenericParams() {
            var genericParams = [];

            var spiceSearchStepSize = {
                id: 'spiceSearchStepSize',
                text: 'Simulation step size',
                default: 60,
                min: 1,
                max: 3600,
                required: true,
                scalar: true
            };
            genericParams.push(spiceSearchStepSize);

            var gsHandoverHours = {
                id: 'gsHandoverHours',
                text: 'Ground station handover (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(gsHandoverHours);

            var scReservedPerPrimaryPassHours = {
                id: 'scReservedPerPrimaryPassHours',
                text: 'Spacecraft reserved primary pass time (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(scReservedPerPrimaryPassHours);

            var scReservedPerExtraPassHours = {
                id: 'scReservedPerExtraPassHours',
                text: 'Spacecraft reserved extra pass time (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(scReservedPerExtraPassHours);

            var passFailurePeriod = {
                id: 'passFailurePeriod',
                text: 'Pass failure period (passes)',
                default: 20,
                min: -1,
                max: 365,
                required: true,
                scalar: true
            };
            genericParams.push(passFailurePeriod);
            var maxRedistributedAllocationHours = {
                id: 'maxRedistributedAllocationHours',
                text: 'Max redistributed allocation (hours)',
                default: 0,
                min: 0,
                max: 999999999,
                required: true,
                scalar: true
            };
            genericParams.push(maxRedistributedAllocationHours);
            return genericParams;
        }

        function createEGSParameters() {
            // cruise phase params
            var cruisePhaseParams = createCruisePhaseParams();

            // nominal phase params
            var nominalPhaseParams = createNominalPhaseParams();

            // generic params
            var genericParams = createGenericParams();

            var params = [];
            params.push(cruisePhaseParams);
            params.push(nominalPhaseParams);
            params.push(genericParams);
            return params;
        }

        function getPickerOpts(dateRangeParam, valueIndex, startDate, endDate, overlappingDates) {
            var optsObj = {
                locale: {
                    applyClass: 'btn-green',
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "YYYY-MM-DD",
                    toLabel: "To",
                    cancelLabel: 'Cancel'
                },
                startDate: startDate,
                endDate: endDate,
                autoApply: true,
                index: valueIndex,
                datesOverlap: overlappingDates
            };

            var resetDates = function (index, newStartDate, newEndDate, newOverlappingDates) {
                dateRangeParam.opts[index] = getPickerOpts(dateRangeParam, index, newStartDate, newEndDate, newOverlappingDates);
                dateRangeParam.value[index] = createTimeRangeObj(prototypeRange);
            };

            var onApply = function () {
                var length = dateRangeParam.value.length;
                if (dateRangeParam.value[optsObj.index].startDate && dateRangeParam.value[optsObj.index].endDate) {
                    var newStartDate = dateRangeParam.value[optsObj.index].startDate.startOf('day');
                    var newEndDate = dateRangeParam.value[optsObj.index].endDate.startOf('day');
                    if (!datesOverlap(dateRangeParam.value, optsObj.index)) {
                        dateRangeParam.opts[optsObj.index] = getPickerOpts(dateRangeParam, optsObj.index, newStartDate, newEndDate);
                        dateRangeParam.value[optsObj.index].startDate = newStartDate;
                        dateRangeParam.value[optsObj.index].endDate = newEndDate;
                        if (optsObj.index === length - 1) {
                            dateRangeParam.opts.push(getPickerOpts(dateRangeParam, length, newEndDate, newEndDate));
                            dateRangeParam.value.push(createTimeRangeObj(prototypeRange));
                        }
                    } else {
                        resetDates(optsObj.index, newStartDate, newEndDate, true);
                    }
                } else {
                    resetDates(optsObj.index, startDate, endDate);
                }
            };


            optsObj.eventHandlers = {
                // 'apply.daterangepicker': onApply,
                'hide.daterangepicker': onApply
            };
            return optsObj;
        }

        function resetParamsInArray(array) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].scalar) {
                    array[i].value = array[i].default;
                }
                if (array[i].dateRanges) {
                    array[i].opts = [];
                    array[i].opts.push(getPickerOpts(array[i], 0, moment().startOf('day'), moment().startOf('day')));
                    array[i].value = [];
                    array[i].value.push(createTimeRangeObj(prototypeRange));
                    if (array[i].textarea) {
                        array[i].showText = false;
                        array[i].valueText = { value: ''};
                    }
                }
            }
        }

        function createTimeRangeObj(proto) {
            return Object.assign({}, proto);
        }

        function datesOverlap(ranges, index) {
            for (var i = 0; i < ranges.length; i++) {
                if (i !== index && ranges[index].startDate && ranges[i].startDate) {
                    var startDateA = ranges[index].startDate.startOf('day');
                    var endDateA = ranges[index].endDate.startOf('day');
                    var startDateB = ranges[i].startDate.startOf('day');
                    var endDateB = ranges[i].endDate.startOf('day');
                    if ((startDateA < endDateB) && (endDateA > startDateB)) {
                        return true;
                    }
                }
            }
            return false;
        }

        function getDateRangesFromString(value) {
            var dateRanges = [];
            var dates = value.replace(/'/g, '').replace(/\s*/g, '').split(',');
            for (var i = 0; i < dates.length -1; i = i+2) {
                var startDate = moment.utc(dates[i]).format('YYYY-MM-DDTHH:mm:ss[Z]')
                var endDate = moment.utc(dates[i+1]).format('YYYY-MM-DDTHH:mm:ss[Z]')
                dateRanges.push({startDate: startDate, endDate: endDate});
            }

            return dateRanges;
        }

        function getDateRangesFromObj(value) {
            var dateRanges = [];
            for (var dateRangeCount in value) {
                if (value[dateRangeCount].startDate !== null && value[dateRangeCount].endDate !== null) {
                    var startDateNoTimeZone = value[dateRangeCount].startDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
                    var endDateNoTimeZone = value[dateRangeCount].endDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
                    dateRanges.push({startDate: startDateNoTimeZone, endDate: endDateNoTimeZone});
                }
            }
            return dateRanges;
        }
    }
})();
